var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass},[_c('img',{class:_vm.imgClass,attrs:{"alt":"Partnering with nCino","data-cy":"sn-partnering","src":"/assets/ncino-watermark.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }